export type LegalBlock = { type: "title" | "heading" | "paragraph"; text: string };

const content: LegalBlock[] = [
  {
    "type": "title",
    "text": "Chính sách quyền riêng tư"
  },
  {
    "type": "paragraph",
    "text": "Chào mừng bạn sử dụng ứng dụng AloVay (sau đây gọi là “Ứng dụng”) được vận hành bởi CÔNG TY TNHH KINH DOANH VINA CASH (sau đây gọi là “Chúng tôi”)."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi đặc biệt coi trọng việc bảo vệ dữ liệu cá nhân và quyền riêng tư của bạn. Chúng tôi cam kết thu thập, sử dụng và quản lý dữ liệu cá nhân của bạn một cách hợp pháp, minh bạch và an toàn theo các quy định pháp luật hiện hành."
  },
  {
    "type": "paragraph",
    "text": "Nhằm giúp bạn hiểu rõ hơn về cách chúng tôi xử lý dữ liệu cá nhân, Chính sách quyền riêng tư này sẽ giải thích:"
  },
  {
    "type": "paragraph",
    "text": "Các loại dữ liệu cá nhân mà chúng tôi thu thập;"
  },
  {
    "type": "paragraph",
    "text": "Cách thức chúng tôi sử dụng, lưu trữ và bảo vệ dữ liệu cá nhân của bạn;"
  },
  {
    "type": "paragraph",
    "text": "Các quyền mà bạn được hưởng trong quá trình xử lý dữ liệu cá nhân."
  },
  {
    "type": "paragraph",
    "text": "Khi sử dụng Ứng dụng, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý với toàn bộ nội dung của Chính sách quyền riêng tư này."
  },
  {
    "type": "paragraph",
    "text": "Chính sách này áp dụng cho tất cả sản phẩm và dịch vụ do chúng tôi cung cấp. Vui lòng đọc kỹ và hiểu đầy đủ nội dung chính sách trước khi sử dụng dịch vụ, đặc biệt là các điều khoản liên quan đến quyền và lợi ích của bạn đối với dữ liệu cá nhân."
  },
  {
    "type": "paragraph",
    "text": "Khi bạn bắt đầu sử dụng sản phẩm hoặc dịch vụ của chúng tôi, hoặc tiếp tục sử dụng dịch vụ sau khi chính sách được cập nhật, điều đó có nghĩa là bạn đã đọc, hiểu và đồng ý với nội dung của Chính sách quyền riêng tư này cũng như các phiên bản cập nhật sau đó."
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn không đồng ý với bất kỳ nội dung nào trong chính sách này, vui lòng ngừng sử dụng sản phẩm hoặc dịch vụ của chúng tôi."
  },
  {
    "type": "paragraph",
    "text": "Thông qua Chính sách quyền riêng tư này, bạn có thể tìm hiểu các nội dung sau:"
  },
  {
    "type": "paragraph",
    "text": "Cam kết của chúng tôi"
  },
  {
    "type": "paragraph",
    "text": "Cách chúng tôi thu thập và sử dụng dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Cách chúng tôi ủy quyền xử lý, chia sẻ, chuyển giao và công khai dữ liệu cá nhân của bạn"
  },
  {
    "type": "paragraph",
    "text": "Thời hạn ủy quyền xử lý dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Cách chúng tôi lưu trữ và bảo vệ dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Các quyền của bạn"
  },
  {
    "type": "paragraph",
    "text": "Cách chúng tôi bảo vệ dữ liệu cá nhân của trẻ vị thành niên"
  },
  {
    "type": "paragraph",
    "text": "Cập nhật và thông báo về chính sách"
  },
  {
    "type": "paragraph",
    "text": "Cách liên hệ với chúng tôi"
  },
  {
    "type": "heading",
    "text": "1. Cam kết của chúng tôi"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi hiểu rõ tầm quan trọng của dữ liệu cá nhân đối với bạn và luôn xem việc bảo vệ an toàn thông tin của bạn là trách nhiệm quan trọng."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ áp dụng các biện pháp hợp lý và hiệu quả để bảo vệ dữ liệu cá nhân của bạn, đồng thời duy trì sự tin tưởng của bạn đối với chúng tôi."
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình xử lý dữ liệu cá nhân, chúng tôi tuân thủ các nguyên tắc sau:"
  },
  {
    "type": "paragraph",
    "text": "Nguyên tắc trách nhiệm và quyền hạn tương ứng;"
  },
  {
    "type": "paragraph",
    "text": "Nguyên tắc xác định rõ mục đích xử lý;"
  },
  {
    "type": "paragraph",
    "text": "Nguyên tắc minh bạch và sự đồng ý của chủ thể dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Nguyên tắc giới hạn trong phạm vi cần thiết;"
  },
  {
    "type": "paragraph",
    "text": "Nguyên tắc đảm bảo an toàn dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Nguyên tắc đảm bảo quyền tham gia của chủ thể dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Nguyên tắc công khai và minh bạch."
  },
  {
    "type": "paragraph",
    "text": "Thông qua Chính sách quyền riêng tư này, chúng tôi mong muốn giúp bạn hiểu rõ về các chức năng dịch vụ, phạm vi dữ liệu được thu thập, phương thức xử lý dữ liệu cũng như các phương thức để bạn chủ động quản lý dữ liệu cá nhân của mình."
  },
  {
    "type": "heading",
    "text": "1.1 Chúng tôi chỉ xử lý dữ liệu cá nhân trong phạm vi cần thiết và hợp lý"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết chỉ thu thập và xử lý dữ liệu cá nhân của bạn trong phạm vi cần thiết, hợp lý nhằm cung cấp và duy trì các chức năng dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Việc xử lý dữ liệu cá nhân của bạn chủ yếu nhằm:"
  },
  {
    "type": "paragraph",
    "text": "Tuân thủ các yêu cầu của pháp luật hiện hành;"
  },
  {
    "type": "paragraph",
    "text": "Cung cấp sản phẩm và dịch vụ an toàn, ổn định, hiệu quả hơn;"
  },
  {
    "type": "paragraph",
    "text": "Cải thiện hoạt động vận hành của nền tảng và nâng cao trải nghiệm người dùng."
  },
  {
    "type": "heading",
    "text": "1.2 Chúng tôi chỉ xử lý dữ liệu cá nhân khi bạn đã được thông báo và đồng ý"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết thông báo cho bạn một cách rõ ràng và minh bạch về:"
  },
  {
    "type": "paragraph",
    "text": "Danh tính và thông tin liên hệ của chúng tôi;"
  },
  {
    "type": "paragraph",
    "text": "Loại dữ liệu cá nhân mà chúng tôi cần xử lý;"
  },
  {
    "type": "paragraph",
    "text": "Mục đích, phương thức xử lý và thời gian lưu trữ dữ liệu."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ cố gắng sử dụng ngôn ngữ đơn giản, dễ hiểu để giải thích các nội dung liên quan."
  },
  {
    "type": "paragraph",
    "text": "Dữ liệu cá nhân nhạy cảm là những dữ liệu mà khi bị tiết lộ, cung cấp trái phép hoặc sử dụng không đúng mục đích có thể gây ảnh hưởng đến an toàn cá nhân, tài sản, danh dự, sức khỏe tinh thần hoặc các quyền lợi hợp pháp khác của cá nhân."
  },
  {
    "type": "paragraph",
    "text": "Trước khi xử lý dữ liệu cá nhân nhạy cảm của bạn, chúng tôi sẽ thông báo về sự cần thiết của việc xử lý, các ảnh hưởng có thể xảy ra đối với quyền lợi cá nhân và thực hiện việc xin sự đồng ý riêng của bạn theo quy định pháp luật."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi tôn trọng quyền lựa chọn của bạn."
  },
  {
    "type": "paragraph",
    "text": "Khi phạm vi thu thập dữ liệu cá nhân, mục đích xử lý hoặc phương thức xử lý có sự thay đổi, chúng tôi sẽ thông báo kịp thời và thực hiện xin lại sự đồng ý của bạn theo yêu cầu pháp luật."
  },
  {
    "type": "heading",
    "text": "1.3 Chúng tôi tôn trọng quyền quản lý dữ liệu cá nhân của bạn"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ áp dụng các biện pháp hợp lý để đảm bảo dữ liệu cá nhân do bạn cung cấp không bị thay đổi, phá hủy hoặc mất mát trái phép."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi hiểu sự quan tâm của bạn đối với vấn đề bảo mật dữ liệu cá nhân và cung cấp các phương thức để bạn thực hiện quyền của chủ thể dữ liệu, bao gồm nhưng không giới hạn:"
  },
  {
    "type": "paragraph",
    "text": "Tra cứu dữ liệu cá nhân;"
  },
  {
    "type": "paragraph",
    "text": "Nhận bản sao dữ liệu cá nhân;"
  },
  {
    "type": "paragraph",
    "text": "Chỉnh sửa hoặc bổ sung dữ liệu cá nhân;"
  },
  {
    "type": "paragraph",
    "text": "Rút lại sự đồng ý;"
  },
  {
    "type": "paragraph",
    "text": "Yêu cầu xóa dữ liệu cá nhân."
  },
  {
    "type": "heading",
    "text": "1.4 Chúng tôi áp dụng các biện pháp cần thiết để đảm bảo an toàn dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết áp dụng các tiêu chuẩn bảo mật phổ biến trong ngành cùng các biện pháp kỹ thuật và quản lý cần thiết nhằm bảo vệ dữ liệu cá nhân của bạn."
  },
  {
    "type": "paragraph",
    "text": "Các biện pháp bao gồm nhưng không giới hạn:"
  },
  {
    "type": "paragraph",
    "text": "Áp dụng các biện pháp bảo vệ về phần cứng, phần mềm, dữ liệu và cơ sở hạ tầng phù hợp với yêu cầu pháp luật và tiêu chuẩn bảo mật hiện hành;"
  },
  {
    "type": "paragraph",
    "text": "Xây dựng hệ thống quản lý an toàn thông tin hoàn chỉnh;"
  },
  {
    "type": "paragraph",
    "text": "Đào tạo nhân viên liên quan về bảo mật dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Ký kết thỏa thuận bảo mật hoặc cam kết bảo mật với nhân viên có liên quan đến việc xử lý dữ liệu cá nhân;"
  },
  {
    "type": "paragraph",
    "text": "Hạn chế quyền truy cập dữ liệu cá nhân nhằm ngăn chặn việc truy cập hoặc sử dụng trái phép."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ liên tục cải thiện hệ thống bảo vệ dữ liệu nhằm đảm bảo an toàn cho thông tin cá nhân của bạn."
  },
  {
    "type": "heading",
    "text": "2. Cách chúng tôi thu thập và sử dụng dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình bạn đăng ký, đăng nhập và sử dụng các sản phẩm, dịch vụ do chúng tôi cung cấp, bạn đồng ý và ủy quyền cho chúng tôi thu thập, sử dụng các dữ liệu cá nhân cần thiết nhằm đáp ứng nhu cầu cung cấp dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết không thu thập các dữ liệu cá nhân bị pháp luật cấm thu thập, đồng thời không sử dụng dữ liệu cá nhân của bạn ngoài phạm vi đã được thông báo và thỏa thuận."
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình cung cấp dịch vụ, chúng tôi có thể thu thập hai nhóm dữ liệu sau:"
  },
  {
    "type": "paragraph",
    "text": "Nhóm thứ nhất: Dữ liệu cần thiết cho các chức năng cơ bản của dịch vụ"
  },
  {
    "type": "paragraph",
    "text": "Đây là các dữ liệu cần thiết để đảm bảo sản phẩm và dịch vụ có thể hoạt động bình thường."
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn từ chối cung cấp các dữ liệu này, bạn có thể không thể sử dụng một số hoặc toàn bộ chức năng cơ bản của dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Nhóm thứ hai: Dữ liệu cần thiết cho các chức năng mở rộng"
  },
  {
    "type": "paragraph",
    "text": "Một số chức năng không thuộc dịch vụ cơ bản có thể yêu cầu thu thập thêm một số dữ liệu liên quan."
  },
  {
    "type": "paragraph",
    "text": "Bạn có quyền lựa chọn có đồng ý cung cấp các dữ liệu này hay không."
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn từ chối cung cấp, một số tính năng có thể không hoạt động hoặc không đạt được hiệu quả dịch vụ mong muốn, nhưng điều này không ảnh hưởng đến việc sử dụng các chức năng cơ bản."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi chỉ thu thập dữ liệu cần thiết khi bạn sử dụng các chức năng tương ứng."
  },
  {
    "type": "paragraph",
    "text": "Khi bạn ngừng sử dụng chức năng đó, chúng tôi sẽ dừng việc tiếp tục thu thập và sử dụng các dữ liệu liên quan."
  },
  {
    "type": "paragraph",
    "text": "Nếu trong tương lai chúng tôi cần thay đổi loại dữ liệu thu thập hoặc mục đích sử dụng dữ liệu, chúng tôi sẽ thông báo trước cho bạn bằng phương thức phù hợp và xin lại sự đồng ý của bạn theo quy định."
  },
  {
    "type": "heading",
    "text": "2.1 Thông tin cá nhân cơ bản"
  },
  {
    "type": "paragraph",
    "text": "Nhằm phục vụ mục đích xác thực danh tính, đăng ký tài khoản, đánh giá rủi ro tín dụng và đảm bảo an toàn dịch vụ, chúng tôi sẽ thu thập số điện thoại mà bạn sử dụng để đăng ký tài khoản như một thông tin nhận dạng chính."
  },
  {
    "type": "paragraph",
    "text": "Tùy theo nhu cầu cung cấp dịch vụ, chúng tôi có thể tiếp tục thu thập các thông tin sau:"
  },
  {
    "type": "paragraph",
    "text": "Họ và tên;"
  },
  {
    "type": "paragraph",
    "text": "Giới tính;"
  },
  {
    "type": "paragraph",
    "text": "Thông tin nghề nghiệp;"
  },
  {
    "type": "paragraph",
    "text": "Thông tin liên quan đến công việc;"
  },
  {
    "type": "paragraph",
    "text": "Thông tin gia đình;"
  },
  {
    "type": "paragraph",
    "text": "Loại và số giấy tờ tùy thân;"
  },
  {
    "type": "paragraph",
    "text": "Hình ảnh giấy tờ tùy thân;"
  },
  {
    "type": "paragraph",
    "text": "Hình ảnh khuôn mặt;"
  },
  {
    "type": "paragraph",
    "text": "Thông tin nhận dạng sinh trắc học;"
  },
  {
    "type": "paragraph",
    "text": "Thông tin tài khoản ngân hàng."
  },
  {
    "type": "paragraph",
    "text": "Các thông tin trên được sử dụng chủ yếu để:"
  },
  {
    "type": "paragraph",
    "text": "Xác minh tính chính xác của danh tính người dùng;"
  },
  {
    "type": "paragraph",
    "text": "Thực hiện đánh giá rủi ro tín dụng;"
  },
  {
    "type": "paragraph",
    "text": "Đề xuất các dịch vụ phù hợp với nhu cầu của bạn;"
  },
  {
    "type": "paragraph",
    "text": "Đảm bảo các giao dịch trên nền tảng được thực hiện hợp pháp, an toàn và đáng tin cậy."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ quản lý và bảo vệ các dữ liệu cá nhân này theo đúng yêu cầu của pháp luật hiện hành."
  },
  {
    "type": "heading",
    "text": "2.2 Thu thập và sử dụng thông tin thiết bị"
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình bạn sử dụng Ứng dụng, nhằm đảm bảo an toàn vận hành nền tảng, xác thực người dùng, phòng chống gian lận và nâng cao khả năng kiểm soát rủi ro, chúng tôi có thể thu thập một số thông tin liên quan đến thiết bị của bạn theo nhu cầu dịch vụ."
  },
  {
    "type": "heading",
    "text": "2.2.1 Thông tin thiết bị"
  },
  {
    "type": "paragraph",
    "text": "Các thông tin có thể được thu thập bao gồm nhưng không giới hạn:"
  },
  {
    "type": "paragraph",
    "text": "Địa chỉ MAC;"
  },
  {
    "type": "paragraph",
    "text": "Model thiết bị;"
  },
  {
    "type": "paragraph",
    "text": "IMEI;"
  },
  {
    "type": "paragraph",
    "text": "GAID;"
  },
  {
    "type": "paragraph",
    "text": "Dung lượng bộ nhớ RAM;"
  },
  {
    "type": "paragraph",
    "text": "Địa chỉ IP;"
  },
  {
    "type": "paragraph",
    "text": "Thông tin Wi-Fi;"
  },
  {
    "type": "paragraph",
    "text": "Tình trạng pin;"
  },
  {
    "type": "paragraph",
    "text": "Độ phân giải màn hình;"
  },
  {
    "type": "paragraph",
    "text": "Cài đặt ngôn ngữ hệ thống;"
  },
  {
    "type": "paragraph",
    "text": "Thông tin nhà sản xuất thiết bị;"
  },
  {
    "type": "paragraph",
    "text": "Loại kết nối mạng;"
  },
  {
    "type": "paragraph",
    "text": "Tên nhà cung cấp dịch vụ di động."
  },
  {
    "type": "paragraph",
    "text": "Các thông tin thiết bị này được sử dụng chủ yếu nhằm:"
  },
  {
    "type": "paragraph",
    "text": "Nâng cao độ chính xác trong việc nhận diện danh tính;"
  },
  {
    "type": "paragraph",
    "text": "Hỗ trợ đánh giá rủi ro;"
  },
  {
    "type": "paragraph",
    "text": "Phát hiện các hành vi bất thường của thiết bị;"
  },
  {
    "type": "paragraph",
    "text": "Ngăn chặn gian lận và các hành vi vi phạm."
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn từ chối cung cấp các thông tin thiết bị liên quan, điều này không ảnh hưởng đến việc sử dụng các chức năng cơ bản của Ứng dụng, tuy nhiên có thể ảnh hưởng đến khả năng đánh giá rủi ro và độ chính xác của một số đề xuất dịch vụ."
  },
  {
    "type": "heading",
    "text": "2.2.2 Danh sách ứng dụng đã cài đặt"
  },
  {
    "type": "paragraph",
    "text": "Nhằm nâng cao khả năng nhận diện rủi ro, đảm bảo tính an toàn và tuân thủ trong quá trình cung cấp dịch vụ cho vay, sau khi nhận được sự đồng ý rõ ràng của bạn, chúng tôi có thể thu thập thông tin về danh sách các ứng dụng đã được cài đặt trên thiết bị."
  },
  {
    "type": "paragraph",
    "text": "Các thông tin có thể bao gồm:"
  },
  {
    "type": "paragraph",
    "text": "Tên ứng dụng;"
  },
  {
    "type": "paragraph",
    "text": "Tên gói ứng dụng (Package Name);"
  },
  {
    "type": "paragraph",
    "text": "Thời gian cài đặt và cập nhật ứng dụng;"
  },
  {
    "type": "paragraph",
    "text": "Phiên bản ứng dụng;"
  },
  {
    "type": "paragraph",
    "text": "Ứng dụng có phải là ứng dụng hệ thống hay không;"
  },
  {
    "type": "paragraph",
    "text": "Nhãn ứng dụng;"
  },
  {
    "type": "paragraph",
    "text": "Đường dẫn cài đặt ứng dụng."
  },
  {
    "type": "paragraph",
    "text": "Các thông tin trên chỉ được sử dụng cho mục đích đánh giá rủi ro và phân tích an toàn."
  },
  {
    "type": "paragraph",
    "text": "Toàn bộ dữ liệu được thu thập sẽ được mã hóa, truyền tải và lưu trữ an toàn tại:"
  },
  {
    "type": "paragraph",
    "text": "admin.alovay.net"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi không sử dụng các thông tin này cho bất kỳ mục đích nào ngoài phạm vi dịch vụ, đồng thời không cung cấp cho bất kỳ bên thứ ba không liên quan nào khi chưa có sự cho phép của bạn."
  },
  {
    "type": "heading",
    "text": "2.2.3 Quyền truy cập vị trí gần đúng"
  },
  {
    "type": "paragraph",
    "text": "Sau khi nhận được sự đồng ý của bạn, chúng tôi có thể thu thập thông tin vị trí gần đúng của bạn."
  },
  {
    "type": "paragraph",
    "text": "Thông tin này chủ yếu được sử dụng để:"
  },
  {
    "type": "paragraph",
    "text": "Xác định bạn có đang ở khu vực được hỗ trợ dịch vụ hay không;"
  },
  {
    "type": "paragraph",
    "text": "Hỗ trợ quá trình đánh giá tín dụng;"
  },
  {
    "type": "paragraph",
    "text": "Nâng cao khả năng kiểm soát rủi ro;"
  },
  {
    "type": "paragraph",
    "text": "Đảm bảo dịch vụ đáp ứng các yêu cầu pháp luật liên quan."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết không sử dụng thông tin vị trí của bạn cho các mục đích không liên quan đến dịch vụ và không tiết lộ thông tin này cho bên thứ ba khi chưa có sự đồng ý rõ ràng của bạn."
  },
  {
    "type": "heading",
    "text": "2.2.4 Quyền truy cập camera"
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình xác minh danh tính, chúng tôi có thể yêu cầu quyền truy cập camera trên thiết bị của bạn."
  },
  {
    "type": "paragraph",
    "text": "Quyền này chỉ được sử dụng cho các mục đích:"
  },
  {
    "type": "paragraph",
    "text": "Chụp và tải lên hình ảnh giấy tờ tùy thân;"
  },
  {
    "type": "paragraph",
    "text": "Thu thập hình ảnh khuôn mặt;"
  },
  {
    "type": "paragraph",
    "text": "Xác minh danh tính thực tế của bạn;"
  },
  {
    "type": "paragraph",
    "text": "Ngăn chặn hành vi giả mạo danh tính và gian lận."
  },
  {
    "type": "paragraph",
    "text": "Thông tin hình ảnh được thu thập chỉ phục vụ mục đích xác minh danh tính và không được sử dụng cho các mục đích khác."
  },
  {
    "type": "paragraph",
    "text": "Toàn bộ dữ liệu hình ảnh sẽ được mã hóa trước khi truyền đến máy chủ của chúng tôi:"
  },
  {
    "type": "paragraph",
    "text": "admin.alovay.net"
  },
  {
    "type": "paragraph",
    "text": "và được lưu trữ theo các tiêu chuẩn bảo mật phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi không sử dụng các thông tin này cho mục đích không liên quan và không cung cấp cho bất kỳ bên thứ ba nào khi chưa có sự đồng ý của bạn."
  },
  {
    "type": "paragraph",
    "text": "Cách chúng tôi ủy quyền xử lý, chia sẻ, chuyển giao và công khai dữ liệu cá nhân của bạn"
  },
  {
    "type": "heading",
    "text": "3.1 Xử lý dữ liệu theo ủy quyền"
  },
  {
    "type": "paragraph",
    "text": "Căn cứ theo Luật Bảo vệ dữ liệu cá nhân của Việt Nam (PDP Law) và các quy định pháp luật liên quan, chúng tôi có thể ủy quyền cho các đơn vị cung cấp dịch vụ bên thứ ba có đủ năng lực và đáp ứng yêu cầu tuân thủ pháp luật để xử lý dữ liệu cá nhân của bạn."
  },
  {
    "type": "paragraph",
    "text": "Các bên được ủy quyền có thể bao gồm:"
  },
  {
    "type": "paragraph",
    "text": "Nhà cung cấp dịch vụ điện toán đám mây;"
  },
  {
    "type": "paragraph",
    "text": "Đơn vị cung cấp dịch vụ phân tích dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Đối tác kiểm soát rủi ro;"
  },
  {
    "type": "paragraph",
    "text": "Các nhà cung cấp dịch vụ kỹ thuật cần thiết khác."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ xác định rõ phạm vi xử lý dữ liệu và trách nhiệm bảo mật của bên được ủy quyền thông qua hợp đồng hoặc các thỏa thuận phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Bên được ủy quyền chỉ được phép xử lý dữ liệu cá nhân của bạn trong phạm vi được chúng tôi cho phép và không được sử dụng dữ liệu cho bất kỳ mục đích nào khác."
  },
  {
    "type": "paragraph",
    "text": "Đồng thời, chúng tôi sẽ tiến hành đánh giá và giám sát về năng lực, khả năng bảo mật dữ liệu và mức độ tuân thủ của các bên được ủy quyền nhằm đảm bảo dữ liệu cá nhân của bạn được bảo vệ hiệu quả."
  },
  {
    "type": "heading",
    "text": "3.2 Chia sẻ dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Trên cơ sở tôn trọng quyền riêng tư của bạn và tuân thủ các quy định pháp luật hiện hành của Việt Nam, chúng tôi có thể chia sẻ một số dữ liệu cá nhân cần thiết với các đối tác đáp ứng yêu cầu tuân thủ nhằm phục vụ nhu cầu kinh doanh hợp pháp."
  },
  {
    "type": "paragraph",
    "text": "Các đối tác có thể bao gồm:"
  },
  {
    "type": "paragraph",
    "text": "Tổ chức tài chính;"
  },
  {
    "type": "paragraph",
    "text": "Đơn vị cung cấp dịch vụ thông tin tín dụng;"
  },
  {
    "type": "paragraph",
    "text": "Nền tảng thanh toán;"
  },
  {
    "type": "paragraph",
    "text": "Các đối tác kinh doanh khác."
  },
  {
    "type": "paragraph",
    "text": "Dữ liệu được chia sẻ có thể được sử dụng cho các mục đích:"
  },
  {
    "type": "paragraph",
    "text": "Đánh giá tín dụng;"
  },
  {
    "type": "paragraph",
    "text": "Kiểm soát rủi ro;"
  },
  {
    "type": "paragraph",
    "text": "Xử lý giao dịch;"
  },
  {
    "type": "paragraph",
    "text": "Cung cấp dịch vụ liên quan."
  },
  {
    "type": "paragraph",
    "text": "Mọi hoạt động chia sẻ dữ liệu đều tuân thủ Luật Bảo vệ dữ liệu cá nhân của Việt Nam (PDP Law), Luật An ninh mạng và các quy định pháp luật liên quan."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi áp dụng các biện pháp bảo mật cần thiết nhằm ngăn chặn việc rò rỉ, sử dụng trái phép hoặc lạm dụng dữ liệu cá nhân."
  },
  {
    "type": "heading",
    "text": "3.3 Chuyển giao dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp xảy ra các hoạt động như sáp nhập công ty, mua bán, tái cơ cấu tài sản hoặc các giao dịch kinh doanh tương tự, dữ liệu cá nhân của bạn có thể được chuyển giao như một phần của tài sản kinh doanh liên quan."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ yêu cầu bên tiếp nhận dữ liệu tiếp tục tuân thủ các quy định pháp luật Việt Nam về bảo vệ dữ liệu cá nhân và chịu trách nhiệm bảo vệ an toàn thông tin của bạn."
  },
  {
    "type": "paragraph",
    "text": "Bên tiếp nhận chỉ được phép sử dụng dữ liệu cá nhân của bạn cho các mục đích kinh doanh hợp pháp, rõ ràng và phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Nếu việc chuyển giao dữ liệu có thể gây ảnh hưởng đáng kể đến quyền và lợi ích cá nhân của bạn, chúng tôi sẽ thông báo cho bạn bằng phương thức phù hợp theo quy định pháp luật và xin ý kiến đồng ý của bạn khi cần thiết."
  },
  {
    "type": "heading",
    "text": "3.4 Công khai dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Theo yêu cầu của pháp luật Việt Nam và các quy định quản lý có liên quan, chúng tôi có thể công khai dữ liệu cá nhân của bạn trong các trường hợp sau:"
  },
  {
    "type": "paragraph",
    "text": "Theo yêu cầu hợp pháp của cơ quan tư pháp, cơ quan quản lý nhà nước để phục vụ điều tra, kiểm tra hoặc xử lý vụ việc;"
  },
  {
    "type": "paragraph",
    "text": "Nhằm phòng ngừa hành vi vi phạm pháp luật, bảo vệ an ninh quốc gia, an toàn công cộng và lợi ích chung của xã hội;"
  },
  {
    "type": "paragraph",
    "text": "Nhằm bảo vệ quyền và lợi ích hợp pháp của bạn, người dùng khác hoặc cộng đồng."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết tuân thủ Luật Bảo vệ dữ liệu cá nhân, Luật An ninh mạng và các quy định pháp luật liên quan."
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình công khai dữ liệu, chúng tôi sẽ áp dụng các biện pháp bảo vệ cần thiết nhằm đảm bảo việc công khai là hợp pháp, phù hợp và tránh việc dữ liệu bị sử dụng sai mục đích."
  },
  {
    "type": "heading",
    "text": "4. Thời hạn ủy quyền xử lý dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Việc ủy quyền xử lý dữ liệu cá nhân theo Chính sách quyền riêng tư này có hiệu lực kể từ thời điểm bạn xác nhận và chấp nhận chính sách."
  },
  {
    "type": "paragraph",
    "text": "Trong thời gian bạn chưa rút lại sự đồng ý hoặc chưa đóng tài khoản, chúng tôi sẽ tiếp tục xử lý dữ liệu cá nhân của bạn trong phạm vi được quy định tại chính sách này."
  },
  {
    "type": "paragraph",
    "text": "Khi bạn rút lại sự đồng ý hoặc hoàn tất việc đóng tài khoản (tùy thời điểm nào xảy ra trước), chúng tôi sẽ dừng việc tiếp tục xử lý dữ liệu cá nhân của bạn theo quy định pháp luật hiện hành và chính sách này."
  },
  {
    "type": "paragraph",
    "text": "Tuy nhiên, trong các trường hợp sau, chúng tôi có thể tiếp tục lưu trữ dữ liệu theo yêu cầu pháp luật:"
  },
  {
    "type": "paragraph",
    "text": "Pháp luật yêu cầu phải tiếp tục lưu trữ;"
  },
  {
    "type": "paragraph",
    "text": "Việc lưu trữ là cần thiết để thực hiện nghĩa vụ pháp lý;"
  },
  {
    "type": "paragraph",
    "text": "Việc lưu trữ cần thiết để giải quyết tranh chấp hoặc bảo vệ quyền lợi hợp pháp."
  },
  {
    "type": "paragraph",
    "text": "Sau khi thời hạn xử lý dữ liệu kết thúc, ngoài các trường hợp nêu trên, chúng tôi sẽ ngừng xử lý dữ liệu cá nhân của bạn và thực hiện các biện pháp hợp lý để xóa hoặc ẩn danh hóa dữ liệu."
  },
  {
    "type": "heading",
    "text": "5. Cách chúng tôi lưu trữ và bảo vệ dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Nhằm đảm bảo an toàn dữ liệu cá nhân của bạn, chúng tôi tuân thủ Luật Bảo vệ dữ liệu cá nhân của Việt Nam (Luật số 10/2023) và Luật An ninh mạng năm 2018, đồng thời áp dụng các biện pháp kỹ thuật và quản lý nhiều lớp để bảo vệ dữ liệu."
  },
  {
    "type": "paragraph",
    "text": "Các biện pháp bảo vệ bao gồm nhưng không giới hạn:"
  },
  {
    "type": "paragraph",
    "text": "Theo yêu cầu tại Điều 5 và Điều 6 của Luật Bảo vệ dữ liệu cá nhân, áp dụng công nghệ mã hóa dữ liệu theo tiêu chuẩn ngành nhằm đảm bảo an toàn dữ liệu trong quá trình truyền tải và lưu trữ;"
  },
  {
    "type": "paragraph",
    "text": "Theo Điều 26 Luật An ninh mạng, lưu trữ dữ liệu cá nhân trên hệ thống máy chủ an toàn đáp ứng yêu cầu pháp luật Việt Nam, đồng thời thường xuyên thực hiện kiểm tra bảo mật và đánh giá rủi ro;"
  },
  {
    "type": "paragraph",
    "text": "Kiểm soát nghiêm ngặt quyền truy cập dữ liệu, chỉ cho phép nhân sự được ủy quyền và có trách nhiệm công việc phù hợp truy cập dữ liệu; nhân viên liên quan phải ký cam kết bảo mật theo Điều 11 của Luật Bảo vệ dữ liệu cá nhân;"
  },
  {
    "type": "paragraph",
    "text": "Xây dựng hệ thống quản lý an toàn thông tin hoàn chỉnh và thường xuyên tổ chức đào tạo nhận thức bảo vệ dữ liệu cho nhân viên;"
  },
  {
    "type": "paragraph",
    "text": "Áp dụng nhiều biện pháp bảo vệ an ninh như tường lửa, hệ thống chống virus, hệ thống phát hiện xâm nhập nhằm ngăn chặn truy cập trái phép, rò rỉ hoặc thay đổi dữ liệu, phù hợp với Điều 29 Luật An ninh mạng;"
  },
  {
    "type": "paragraph",
    "text": "Xây dựng quy trình ứng phó sự cố an toàn dữ liệu. Trong trường hợp xảy ra sự cố như rò rỉ, mất mát hoặc thay đổi dữ liệu, chúng tôi sẽ kịp thời kích hoạt cơ chế xử lý khẩn cấp và thông báo cho người dùng cũng như cơ quan có thẩm quyền theo quy định pháp luật."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết không ngừng hoàn thiện hệ thống bảo vệ dữ liệu cá nhân, nâng cao năng lực bảo mật và đảm bảo quyền lợi hợp pháp của bạn."
  },
  {
    "type": "heading",
    "text": "6. Các quyền của bạn"
  },
  {
    "type": "paragraph",
    "text": "Theo Luật Bảo vệ dữ liệu cá nhân của Việt Nam (PDP Law) và các quy định pháp luật liên quan, với tư cách là chủ thể dữ liệu cá nhân, bạn có các quyền sau đây:"
  },
  {
    "type": "heading",
    "text": "6.1 Quyền truy cập dữ liệu"
  },
  {
    "type": "paragraph",
    "text": "Bạn có quyền yêu cầu chúng tôi cung cấp thông tin về dữ liệu cá nhân của bạn mà chúng tôi đang lưu giữ, bao gồm nhưng không giới hạn:"
  },
  {
    "type": "paragraph",
    "text": "Loại dữ liệu cá nhân được thu thập;"
  },
  {
    "type": "paragraph",
    "text": "Nguồn dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Mục đích xử lý;"
  },
  {
    "type": "paragraph",
    "text": "Phương thức xử lý;"
  },
  {
    "type": "paragraph",
    "text": "Thời gian lưu trữ;"
  },
  {
    "type": "paragraph",
    "text": "Tình trạng chia sẻ dữ liệu."
  },
  {
    "type": "paragraph",
    "text": "Bạn có quyền tìm hiểu cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ dữ liệu cá nhân của bạn, đồng thời có thể yêu cầu cung cấp bản sao dữ liệu cá nhân."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ xử lý yêu cầu của bạn trong thời gian hợp lý và phản hồi kết quả kịp thời."
  },
  {
    "type": "heading",
    "text": "6.2 Quyền chỉnh sửa dữ liệu"
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn phát hiện dữ liệu cá nhân mà chúng tôi đang lưu giữ có sai sót, không đầy đủ hoặc đã thay đổi, bạn có quyền yêu cầu chúng tôi chỉnh sửa hoặc bổ sung thông tin tương ứng."
  },
  {
    "type": "paragraph",
    "text": "Sau khi nhận được yêu cầu, chúng tôi sẽ tiến hành xác minh và hoàn tất việc xử lý trong thời gian hợp lý nhằm đảm bảo dữ liệu cá nhân của bạn luôn chính xác và đầy đủ."
  },
  {
    "type": "heading",
    "text": "6.3 Quyền xóa dữ liệu"
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, bạn có quyền yêu cầu chúng tôi xóa dữ liệu cá nhân của mình."
  },
  {
    "type": "paragraph",
    "text": "Ví dụ:"
  },
  {
    "type": "paragraph",
    "text": "Dữ liệu không còn cần thiết cho mục đích thu thập hoặc xử lý ban đầu;"
  },
  {
    "type": "paragraph",
    "text": "Việc xử lý dữ liệu cá nhân của bạn không tuân thủ quy định pháp luật."
  },
  {
    "type": "paragraph",
    "text": "Sau khi nhận được yêu cầu xóa dữ liệu, chúng tôi sẽ tiến hành đánh giá theo quy định và thực hiện việc xóa hoặc ẩn danh hóa dữ liệu khi phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Tuy nhiên, trong trường hợp pháp luật yêu cầu tiếp tục lưu trữ dữ liệu, chúng tôi sẽ thực hiện theo các quy định hiện hành."
  },
  {
    "type": "heading",
    "text": "6.4 Quyền hạn chế xử lý dữ liệu"
  },
  {
    "type": "paragraph",
    "text": "Trong một số trường hợp nhất định, bạn có quyền yêu cầu chúng tôi hạn chế việc xử lý dữ liệu cá nhân của bạn."
  },
  {
    "type": "paragraph",
    "text": "Ví dụ:"
  },
  {
    "type": "paragraph",
    "text": "Bạn có nghi ngờ hoặc không đồng ý về tính chính xác của dữ liệu cá nhân;"
  },
  {
    "type": "paragraph",
    "text": "Bạn phản đối hoạt động xử lý dữ liệu và yêu cầu xác minh thêm."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ xem xét yêu cầu của bạn trong thời gian hợp lý và áp dụng các biện pháp hạn chế xử lý phù hợp nhằm bảo vệ quyền lợi của bạn."
  },
  {
    "type": "heading",
    "text": "6.5 Quyền chuyển dữ liệu"
  },
  {
    "type": "paragraph",
    "text": "Bạn có quyền yêu cầu chúng tôi cung cấp bản sao dữ liệu cá nhân của bạn dưới định dạng có cấu trúc, thông dụng và có thể đọc được bằng máy, nhằm tạo điều kiện để bạn chuyển dữ liệu sang nhà cung cấp dịch vụ khác."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ hỗ trợ bạn trong phạm vi hợp lý để đảm bảo việc tiếp nhận và chuyển giao dữ liệu cá nhân được thực hiện thuận tiện và an toàn."
  },
  {
    "type": "heading",
    "text": "6.6 Quyền rút lại sự đồng ý"
  },
  {
    "type": "paragraph",
    "text": "Nếu trước đây bạn đã đồng ý cung cấp dữ liệu cá nhân cho chúng tôi, bạn có quyền rút lại sự đồng ý đó bất kỳ lúc nào."
  },
  {
    "type": "paragraph",
    "text": "Sau khi rút lại sự đồng ý:"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ dừng các hoạt động xử lý dữ liệu dựa trên sự đồng ý đó;"
  },
  {
    "type": "paragraph",
    "text": "Việc rút lại sự đồng ý không ảnh hưởng đến tính hợp pháp của các hoạt động xử lý dữ liệu đã được thực hiện trước thời điểm rút lại."
  },
  {
    "type": "paragraph",
    "text": "Xin lưu ý rằng việc rút lại sự đồng ý có thể khiến một số chức năng dịch vụ không thể tiếp tục sử dụng. Trong trường hợp cần thiết, chúng tôi sẽ thông báo cho bạn về những ảnh hưởng liên quan."
  },
  {
    "type": "heading",
    "text": "6.7 Quyền khiếu nại"
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn cho rằng chúng tôi đã xâm phạm quyền và lợi ích hợp pháp của bạn trong quá trình xử lý dữ liệu cá nhân, bạn có quyền gửi khiếu nại đến chúng tôi."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết tiếp nhận, kiểm tra và xử lý các phản ánh của bạn trong thời gian phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Ngoài ra, bạn có quyền gửi khiếu nại hoặc báo cáo đến Cục An toàn thông tin Việt Nam (NCSC) hoặc các cơ quan quản lý có thẩm quyền khác để được bảo vệ quyền lợi theo pháp luật."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ phối hợp với các cơ quan liên quan trong quá trình xử lý theo quy định."
  },
  {
    "type": "heading",
    "text": "6.8 Quyền đóng tài khoản"
  },
  {
    "type": "paragraph",
    "text": "Bạn có quyền yêu cầu đóng tài khoản của mình bất cứ lúc nào."
  },
  {
    "type": "paragraph",
    "text": "Sau khi tài khoản được đóng, chúng tôi sẽ xóa hoặc ẩn danh hóa dữ liệu cá nhân của bạn trong phạm vi pháp luật cho phép."
  },
  {
    "type": "paragraph",
    "text": "Nếu pháp luật yêu cầu tiếp tục lưu trữ một số dữ liệu nhất định, chúng tôi sẽ thực hiện theo quy định hiện hành."
  },
  {
    "type": "paragraph",
    "text": "Bạn có thể gửi yêu cầu đóng tài khoản thông qua thông tin liên hệ được cung cấp ở cuối Chính sách quyền riêng tư này."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ xử lý yêu cầu trong thời gian hợp lý và thông báo kết quả cho bạn."
  },
  {
    "type": "paragraph",
    "text": "Xin lưu ý rằng việc đóng tài khoản có thể khiến bạn không thể tiếp tục sử dụng một phần hoặc toàn bộ dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ nỗ lực tối đa để hỗ trợ bạn thực hiện các quyền liên quan đến dữ liệu cá nhân."
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn muốn thực hiện bất kỳ quyền nào nêu trên, vui lòng liên hệ với chúng tôi thông qua thông tin liên hệ cuối chính sách."
  },
  {
    "type": "heading",
    "text": "7. Cách chúng tôi bảo vệ dữ liệu cá nhân của trẻ vị thành niên"
  },
  {
    "type": "paragraph",
    "text": "Theo Luật Bảo vệ dữ liệu cá nhân của Việt Nam (Luật số 10/2023) và các quy định pháp luật liên quan, việc bảo vệ dữ liệu cá nhân của trẻ vị thành niên (người dưới 18 tuổi) được đặc biệt quan tâm."
  },
  {
    "type": "paragraph",
    "text": "Nhằm bảo vệ quyền và lợi ích hợp pháp của trẻ vị thành niên, khi xử lý dữ liệu cá nhân của nhóm đối tượng này, chúng tôi áp dụng các biện pháp sau:"
  },
  {
    "type": "paragraph",
    "text": "Trước khi thu thập và sử dụng dữ liệu cá nhân của trẻ vị thành niên, chúng tôi sẽ có được sự đồng ý rõ ràng của người đại diện hợp pháp (như cha mẹ hoặc người giám hộ) theo quy định pháp luật;"
  },
  {
    "type": "paragraph",
    "text": "Giới hạn nghiêm ngặt phạm vi thu thập dữ liệu cá nhân của trẻ vị thành niên, chỉ thu thập những dữ liệu cần thiết để cung cấp dịch vụ;"
  },
  {
    "type": "paragraph",
    "text": "Áp dụng các biện pháp bảo mật nghiêm ngặt hơn nhằm ngăn chặn việc rò rỉ, lạm dụng hoặc truy cập trái phép dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Không sử dụng dữ liệu cá nhân của trẻ vị thành niên cho mục đích quảng cáo hoặc các mục đích không cần thiết nếu chưa có sự đồng ý của người giám hộ;"
  },
  {
    "type": "paragraph",
    "text": "Khi phát hiện dữ liệu cá nhân của trẻ vị thành niên bị thu thập hoặc xử lý trái phép, chúng tôi sẽ kịp thời thực hiện các biện pháp cần thiết để xóa dữ liệu liên quan và thông báo cho người giám hộ."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi cam kết tuân thủ các quy định pháp luật Việt Nam và liên tục bảo vệ an toàn dữ liệu cá nhân của trẻ vị thành niên."
  },
  {
    "type": "heading",
    "text": "8. Cập nhật và thông báo về Chính sách quyền riêng tư"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi có thể điều chỉnh hoặc cập nhật Chính sách quyền riêng tư này theo sự thay đổi của pháp luật, nhu cầu phát triển kinh doanh hoặc yêu cầu quản lý an toàn thông tin."
  },
  {
    "type": "paragraph",
    "text": "Khi chính sách được cập nhật, chúng tôi có thể thông báo cho bạn thông qua các phương thức sau:"
  },
  {
    "type": "paragraph",
    "text": "Thông báo trong Ứng dụng;"
  },
  {
    "type": "paragraph",
    "text": "Tin nhắn;"
  },
  {
    "type": "paragraph",
    "text": "Email;"
  },
  {
    "type": "paragraph",
    "text": "Các phương thức thông báo hợp lý khác."
  },
  {
    "type": "paragraph",
    "text": "Sau khi nhận được thông báo cập nhật, vui lòng đọc kỹ phiên bản mới nhất của Chính sách quyền riêng tư."
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn tiếp tục sử dụng sản phẩm hoặc dịch vụ của chúng tôi, điều đó có nghĩa là bạn đã đọc, hiểu và đồng ý với nội dung chính sách được cập nhật."
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn không đồng ý với nội dung cập nhật, bạn có quyền ngừng sử dụng dịch vụ liên quan và thực hiện các quyền về dữ liệu cá nhân theo quy định trong chính sách này."
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi khuyến nghị bạn thường xuyên kiểm tra Chính sách quyền riêng tư để kịp thời nắm được các biện pháp bảo vệ dữ liệu và quy định dịch vụ mới nhất."
  },
  {
    "type": "heading",
    "text": "9. Cách liên hệ với chúng tôi"
  },
  {
    "type": "paragraph",
    "text": "Nếu bạn có bất kỳ câu hỏi, ý kiến hoặc yêu cầu nào liên quan đến Chính sách quyền riêng tư này hoặc muốn thực hiện các quyền đối với dữ liệu cá nhân của mình, vui lòng liên hệ với chúng tôi thông qua:"
  },
  {
    "type": "paragraph",
    "text": "Email:\nservice@alovay.net"
  },
  {
    "type": "paragraph",
    "text": "Số điện thoại chăm sóc khách hàng:\n+84-898653221"
  },
  {
    "type": "paragraph",
    "text": "Địa chỉ văn phòng:\nTầng 8 UOA Tower số 6 Tân Trào, Khu đô thị Phú Mỹ Hưng, Phường Tân Mỹ, Thành phố Hồ Chí Minh, Việt Nam"
  },
  {
    "type": "paragraph",
    "text": "Chúng tôi sẽ phản hồi yêu cầu của bạn trong thời gian sớm nhất và hỗ trợ giải quyết các vấn đề liên quan, nhằm đảm bảo an toàn dữ liệu cá nhân và bảo vệ quyền lợi hợp pháp của bạn."
  }
];

export default content;
